export default {
    BUTTON_VIEW: 'button',
    TEXT_VIEW: 'text',
};
